import { combineReducers } from "redux"
import { persistReducer } from "redux-persist"
import storage from "redux-persist/lib/storage"
import auth from "./auth"
import invitePeople from "./invitePeople"
import loadingState from "./loadingState"
import chatData from "./chatData"
import planDinner from "./planDinner"
import orderAndPayments from "./orderAndPayments"
import partner from "./partner"
import developer from "./developer"
import sharedProfile from "./sharedProfile"

const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "auth",
    "chatData",
    "planDinner",
    "invitePeople",
    "orderAndPayments",
    "partner",
    "developer",
    "sharedProfile",
  ],
  blacklist: ["loadingState"],
}

const rootReducer = combineReducers({
  auth,
  invitePeople,
  chatData,
  planDinner,
  orderAndPayments,
  partner,
  developer,
  sharedProfile,
  loadingState,
})

export default persistReducer(persistConfig, rootReducer)
